import React, { useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { Document, Page, pdfjs } from "react-pdf";
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PDFDialog(props) {

    const classes = useStyles();
    let history = useHistory();
    const { t } = useTranslation();

    useEffect(() => {
        // pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
        pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.js`;
        
    }, [props.dialogOpen]);


    function PaperComponent(props) {
        return (
            <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper  {...props} />
            </Draggable>
        );
    }

    let pdfFileName = "";
    let numberOfPages = 0;
    if (history.location.pathname === '/') {
        pdfFileName = "Werkstations"
        numberOfPages = 4
    }
    if (history.location.pathname.includes("workstation")) {
        pdfFileName = "Productielijst"
        numberOfPages = 10
    }
    if (history.location.pathname.includes("order")) {
        pdfFileName = "Orderdetail"
        numberOfPages = 20
    }   
    if (history.location.pathname.includes("qualitychecks")) {
        pdfFileName = "Kwaliteit"
        numberOfPages = 9
    }  
    if (history.location.pathname.includes("sampling")) {
        pdfFileName = "Kwaliteit"
        numberOfPages = 9
    }  

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            onClose={props.closeDialog}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >{props.dialogOpen && pdfFileName !== ""?
            <Document
                file={process.env.PUBLIC_URL + '/helpfiles/' + pdfFileName + '.pdf'}
                options={{ workerSrc: "/pdf.worker.js" }}
                className={classes.document}
            // onLoadSuccess={onDocumentLoadSuccess}
            >
                {Array.from(new Array(numberOfPages), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
            </Document> : <div className = {classes.noDoc}>{t("There are no helpfiles found for this page")}</div>}
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.okButton} autoFocus onClick={props.closeDialog}>
                        OK
                 </Button>
                </div>
            </DialogActions>

        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "1000px !important",
        margin: "auto",
        height: "90% !important",
        '& .MuiDialog-paper': {
            overflowY: "unset",
            height: "1000px",
        },
    },
    buttons: {
        width: "612px",
        textAlign: "center"
    },
    okButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "50px",
        marginBottom: "20px",
        position: "relative",
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "0px"
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    document: {
        height: "1000px",
        overflowY: "auto",
        overflowX: "hidden"
    },
    noDoc:{
        height: "1000px",
        overflowY: "auto",
        overflowX: "hidden",
        padding:"20px"
    }

}));
